import { Address } from 'features/Form/AddressForm/AddressForm.types'
import { functions } from '..'
import { Sale } from 'core/logic/asset/asset.types'
import { DeliveryQuotation } from '@onepercentio/rarum-types/logistics'

export async function getQuotations(destinationAddress: Address, sale: Sale) {
  return functions
    .httpsCallable(`logistics-generateQuotation`)({
      tenantId: process.env.REACT_APP_TENANT_IDENTITY_ID,
      orderId: sale.offerId,
      addressTo: destinationAddress,
    })
    .then(({ data }) => data as DeliveryQuotation[])
}

export async function getTrackingLabel(deliveryId: string) {
  return functions
    .httpsCallable(`logistics-getLabel`)({
      deliveryId,
      tenantId: process.env.REACT_APP_TENANT_IDENTITY_ID,
    })
    .then(({ data }) => data as string)
}
